import { configureStore } from "@reduxjs/toolkit";
import tasksReducer from "./tasksSlice";
import { createStateSyncMiddleware } from "redux-state-sync";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import currentTaskReducer from "./currentTaskSlice";
const persistConfig = {
    key: "root",
    storage,
};
const persistedTasks = persistReducer(persistConfig, tasksReducer);
export const store = configureStore({
    reducer: {
        tasks: persistedTasks,
        currentTask: currentTaskReducer,
    },
    middleware: [
        createStateSyncMiddleware({
            blacklist: ["persist/PERSIST", "persist/REHYDRATE"],
        }),
    ],
});
